module.exports = __webpack_public_path__ + "c081a4cc3015cedc1fe70dc74973d823.svg";